<template lang="pug">
  .container.grid-xl
    page-title(icon="fas fa-ticket-alt" :title="title" :subtitle="subtitle")
    .flex-centered.full-height(v-if="error") #[error-box(:error="error")]
    fieldset(v-else :disabled="loading")
      form(@submit.prevent="onSubmit")
        .columns
          .column.col-6.col-lg-7.col-md-8.col-sm-12
            .columns
              .column.col-6.col-sm-12
                form-group(label="Código" :validation="$v.coupon" field="code")
                  input.form-input(v-model.trim="$v.coupon.code.$model")
              .column.col-6.col-sm-12
                form-group(label="Valor" :validation="$v.coupon" field="value")
                  masked-money.form-input(v-model="$v.coupon.value.$model" v-bind="valueAttrs")
              .column.col-6.col-sm-12
                form-group(label="Expira em" :validation="$v.coupon" field="expiresIn")
                  datepicker(v-model="$v.coupon.expiresIn.$model" :attrs="bindDateAttrs")
              .column.col-6.col-sm-12
                form-group(label="Quantidade" :validation="$v.coupon" field="amount")
                  input.form-input(type="number" min="0" v-model.number="$v.coupon.amount.$model")
              .column.col-6.col-sm-12
                .form-group
                  label.form-label Tipo de desconto
                  label.form-radio.form-inline
                    input(type="radio" value="fixed" v-model="$v.coupon.discountType.$model")
                    i.form-icon
                    span Valor fixo
                  label.form-radio.form-inline
                    input(type="radio" value="percent" v-model="$v.coupon.discountType.$model")
                    i.form-icon
                    span Percentual
            .divider
            .text-right
              button.btn.btn-primary(:disabled="disabled") Salvar
</template>

<script>
import {
  required,
  numeric,
  minValue,
  requiredIf,
} from 'vuelidate/lib/validators'
import coupons from '@/services/coupons'

export default {
  data() {
    return {
      loading: false,
      error: null,
      coupon: {
        code: '',
        value: 0,
        amount: 0,
        discountType: 'fixed',
        expiresIn: '',
      },
    }
  },
  computed: {
    disabled() {
      return this.loading || this.$v.$invalid
    },
    bindDateAttrs() {
      return { disabledDate: date => date < new Date() }
    },
    valueAttrs() {
      if (this.coupon.discountType === 'fixed') return { prefix: 'R$ ' }
      return { suffix: ' %' }
    },
    title() {
      return this.$route.params.id ? 'Editar cupom' : 'Novo cupom'
    },
    subtitle() {
      return 'Este cupom vai dar desconto nas compras'
    },
  },
  validations: {
    coupon: {
      code: { required },
      value: { required },
      discountType: { required },
      expiresIn: { required: requiredIf(model => !model.amount) },
      amount: { required: requiredIf(model => !model.expiresIn) },
    },
  },
  methods: {
    async onSubmit() {
      const { coupon } = this
      const submitFunction = coupon.id ? coupons.update : coupons.create
      try {
        this.loading = true
        await submitFunction(this.coupon)
        this.$toaster.success('O cupom foi salvo')
        this.$router.back()
      } catch (e) {
        this.$toaster.error(e.message)
      } finally {
        this.loading = false
      }
    },
  },
  async created() {
    if (!this.$route.params.id) return
    try {
      const { data } = await coupons.show(this.$route.params.id)
      this.coupon = data
    } catch (e) {
      this.error = e
    } finally {
      this.loading = false
    }
  },
}
</script>
